// ======================================================================
// File Name       : LiveReservedDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as UsageSettingLiveAction from '../../actions/UsageSettingLiveActions';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import LiveReservedDetailInfo from '../../components/usageSettingLive/LiveReservedDetailInfo';
import LiveReservedDetailRecordedFileList from '../../components/usageSettingLive/LiveReservedDetailRecordedFileList';
import LiveReservedDetailUserList from '../../components/usageSettingLive/LiveReservedDetailUserList';
import LiveReservedUserAttributeList from '../../components/usageSettingLive/LiveReservedUserAttributeList';
import * as FunctionConstants from '../../constants/FunctionConstants';
import { MODE } from '../../constants/index';
import { LIVE_SITUATION } from '../../constants/LivePerformanceConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { LIVE_RESERVED_EDIT } from '../../constants/PathConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class LiveReservedDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canAccess: false,
      showDeleteModal: false,
    };
    this.getLiveReservedDetail = this.getLiveReservedDetail.bind(this);
    this.deleteLiveReservation = this.deleteLiveReservation.bind(this);
    this.onDeleteDialogOk = this.onDeleteDialogOk.bind(this);
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind(this);
    this.goBack = this.goBack.bind(this);
    this.goToEdit = this.goToEdit.bind(this);
    this.downloadRecordFile = this.downloadRecordFile.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (!match.params || !match.params.id) {
      this.props.history.goBack();
    }
    const canAccess = canAccessRoute(FunctionConstants.LIVE_RESERVED_EDIT);
    this.getLiveReservedDetail(match.params.id, canAccess);
  }

// #7129 START
  componentWillUnmount() {
    this.props.dispatch(UsageSettingLiveAction.resetLiveReservedDetail());
  }
// #7129 END

  getLiveReservedDetail(liveSecernId, canAccess) {
    const param = {};
    param.searchInfo = { liveList: [liveSecernId], includeCompletedLive: 1 };
    this.setState(
      {
        canAccess,
      },
      () => {
        this.props.dispatch(UsageSettingLiveAction.getLiveReservedDetail(param));
      },
    );
  }

  deleteLiveReservation() {
    const { match } = this.props;
    if (!match.params || !match.params.id) {
      return;
    }
    this.setState({
      showDeleteModal: true,
    });
  }

  onDeleteDialogOk() {
    const { match, userLiveRelationList } = this.props;
    const liveSecernId = match.params.id;
    const paramLive = {};
    paramLive.editType = MODE.DELETE_MODE;
    paramLive.liveInfo = { liveSecernId };
    const paramUserLiveRelation = {};
    paramUserLiveRelation.editType = MODE.DELETE_MODE;
    paramUserLiveRelation.liveInfo = {};
    if (
      userLiveRelationList &&
      userLiveRelationList.allSecernIds &&
      userLiveRelationList.allSecernIds
    ) {
      paramUserLiveRelation.liveInfo.liveSecernId = liveSecernId;
      paramUserLiveRelation.liveInfo.userList = userLiveRelationList.allSecernIds;
    }
    this.setState(
      {
        showDeleteModal: false,
      },
      () => {
        this.props
          .dispatch(UsageSettingLiveAction.deleteLiveReservation(paramLive, paramUserLiveRelation))
          .then((error) => {
            if (!error) {
              this.goBack();
            }
          });
      },
    );
  }

  onDeleteDialogCancel() {
    this.setState({
      showDeleteModal: false,
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  goToEdit() {
    const { match } = this.props;
    if (!match.params || !match.params.id) {
      return;
    }
    const path = LIVE_RESERVED_EDIT.replace(':id', match.params.id);
    this.props.history.push(path);
  }

  downloadRecordFile(recordId) {
    const param = { recordId };
    this.props.dispatch(UsageSettingLiveAction.downloadRecordedVideo(param));
  }

  render() {
    const { liveReserveDetail, userLiveRelationList, userAttributeList, userLiveRecordedFileList } = this.props;
    let showBtn = false;
    let showLiveRecordedFileList = false;
    if (liveReserveDetail &&
        liveReserveDetail.liveSecernId) {
      if (liveReserveDetail.liveSituation === LIVE_SITUATION.BEFORE_OPEN) {
        showBtn = true;
      }
      if (liveReserveDetail.liveSituation === LIVE_SITUATION.AFTER_OPEN) {
        showLiveRecordedFileList = true;
      }
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.LIVE_RESERVED_LIST}
          text="ライブ一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ライブ情報の詳細" />
        <LiveReservedDetailInfo {...liveReserveDetail} />
        <LiveReservedDetailUserList
          {...liveReserveDetail}
          userLiveRelationList={userLiveRelationList}
        />

        {showLiveRecordedFileList && (
          <LiveReservedDetailRecordedFileList
            userLiveRecordedFileList={userLiveRecordedFileList}
            downloadRecordFile={this.downloadRecordFile}
          />
        )}

        <LiveReservedUserAttributeList userAttributeList={userAttributeList} />
        <Col sm={12} className="text-center margin-top-20">
          {this.state.canAccess && showBtn && (
            <Button variant="primary" className="btn-96 margin-10" onClick={this.goToEdit}>
              編集
            </Button>
          )}
          {this.state.canAccess && showBtn && (
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.deleteLiveReservation}
            >
              削除
            </Button>
          )}
        </Col>
        <DialogConfirm
          showModal={this.state.showDeleteModal}
          onCancel={this.onDeleteDialogCancel}
          content={MessageTemplate.MSG_DEL_LIVE}
          onOK={this.onDeleteDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    liveReserveDetail,
    liveReservedDetailUsers,
    userLiveRelationList,
    userAttributeList,
    userLiveRecordedFileList,
  } = state.usageSettingLive;
  return {
    liveReserveDetail,
    liveReservedDetailUsers,
    userLiveRelationList,
    userAttributeList,
    userLiveRecordedFileList,
  };
};

export default connect(mapStateToProps)(LiveReservedDetailContainer);
